/* global wpConfig */

import axios from "axios";

const retryInterval = 50;
const queueRules = {
  all: {
    concurrency: 4
  },
  basket_reserve: {
    concurrency: 1
  },
  basket_update: {
    concurrency: 1
  }
};

const queuePending = {
  all: 0,
  basket_reserve: 0,
  basket_update: 0
};

function getQueueName(config) {
  if (config.queueName) return config.queueName;

  return "all";
}

function handleZUXResponse(response) {
  if (typeof response.headers["x-zux-type"] !== "undefined") {
    switch (response.headers["x-zux-type"]) {
      case "UIResponse":
        if (response.data.notices) {
          window.dispatchEvent(
            new CustomEvent("notices", {
              detail: response.data.notices
            })
          );
        }

        response.state = response.data.state;
        response.notices = response.data.notices;
        response.data = response.data.return;

        break;
    }
  }

  return response;
}

var headers = {};

if (wpConfig.nonce) {
  headers["X-WP-Nonce"] = wpConfig.nonce;
}

const axiosInstance = axios.create({
  withCredentials: true,
  headers,
  baseURL: wpConfig.rest_url
});

axiosInstance.CancelToken = axios.CancelToken;

axiosInstance.interceptors.request.use(function(config) {
  let queueName = getQueueName(config);

  config.headers["X-ZUX-Origin-Time"] = config.origin_time ?? Date.now();

  return new Promise(resolve => {
    let interval = setInterval(() => {
      if (queuePending[queueName] < queueRules[queueName].concurrency) {
        queuePending[queueName]++;
        clearInterval(interval);
        resolve(config);
      }
    }, retryInterval);
  });
});

/* Interceptor to handle errors and action X-ZUX-Type responses, which can manipulate the commonui state */

axiosInstance.interceptors.response.use(
  function(response) {
    let queueName = getQueueName(response.config);
    queuePending[queueName] = Math.max(0, queuePending[queueName] - 1);
    response = handleZUXResponse(response);
    return Promise.resolve(response);
  },
  function(error) {
    if (axios.isCancel(error)) {
      let queueName = getQueueName({ queueName: error.message });
      queuePending[queueName] = Math.max(0, queuePending[queueName] - 1);
      return error;
    } else {
      let queueName = getQueueName(error.response.config);
      queuePending[queueName] = Math.max(0, queuePending[queueName] - 1);
    }

    if (!error.request) {
      return Promise.reject(error);
    }

    if (error.request.status === 0) {
      // Offline.
      window.dispatchEvent(
        new CustomEvent("disconnected", {
          detail: error
        })
      );
      return Promise.reject(error);
    }

    error.response = handleZUXResponse(error.response);

    return Promise.reject(error);
  }
);

export default axiosInstance;
